<template lang="pug">
  apollo-query(
    :query="query"
    :fetchPolicy="fetchPolicy"
    @result="onResult")
    template(slot-scope="{ result: { loading, error, data } }")
      slot(:students="students") Implement required
</template>

<script>
import { FETCH_CONTRACTED_STUDENTS_QUERY } from '@/graphql'
import createStudent from '@/entities/Student'

export default {
  props: {
    fetchPolicy: { type: String, default: 'cache-first' },
  },
  data() {
    return {
      query: FETCH_CONTRACTED_STUDENTS_QUERY,
      students: [],
    }
  },
  methods: {
    onResult(result) {
      this.students = result.data.viewer.contractedStudents.edges.map((e) =>
        createStudent(e.node.student)
      )
    },
  },
}
</script>
